import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks/useTypedSelector";
import { selectIsAuthenticated } from '@/redux/selectors/authSelector';

interface Props {
  children: React.ReactNode;
  redirectPath?: string;
}

const AuthProvider = ({ children, redirectPath = "/sign-in" }: Props) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);;
  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }
  return <>{children}</>;
};

export default AuthProvider;
